"use strict";

exports.__esModule = true;
exports.MasterDetailView = MasterDetailView;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Theme = require("../../Theme");
var _whenModern = require("../../Theme/UiDesign/whenModern");
var _excluded = ["selected", "onSelect", "children", "renderMaster", "renderDetail", "DetailWrapper", "MasterWrapper", "ContainerWrapper"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Container = _styledComponents["default"].div.withConfig({
  displayName: "MasterDetailView__Container",
  componentId: "sc-axx4zt-0"
})(["overflow-x:hidden;flex:1;"]);
var Master = _styledComponents["default"].div.withConfig({
  displayName: "MasterDetailView__Master",
  componentId: "sc-axx4zt-1"
})(["position:relative;height:100%;z-index:2;opacity:1;transition:opacity 0.25s ease-in;&.hasExpandedDetail{opacity:0.8;}"]);
var Detail = _styledComponents["default"].div.withConfig({
  displayName: "MasterDetailView__Detail",
  componentId: "sc-axx4zt-2"
})(["position:absolute;opacity:0;top:0;z-index:1;left:calc(100% - 300px);width:calc(100% - 300px);height:100vh;background:", ";transition:opacity 0.25s ease-in,left 0.25s ease-in,box-shadow 0.5s ease-in,z-index 0.25s ease-in;&.hasExpandedDetail{box-shadow:-20px 2px 35px -19px rgba(0,0,0,0.3);left:300px;z-index:3;opacity:1;", "}"], (0, _Theme.val)("background"), (0, _whenModern.whenModern)((0, _styledComponents.css)(["border-left:1px solid ", ";box-shadow:-12px 0 32px -16px rgba(29,36,41,0.35);"], (0, _Theme.val)("borderColor"))));
function MasterDetailView(_ref) {
  var selected = _ref.selected,
    onSelect = _ref.onSelect,
    children = _ref.children,
    renderMaster = _ref.renderMaster,
    renderDetail = _ref.renderDetail,
    _ref$DetailWrapper = _ref.DetailWrapper,
    DetailWrapper = _ref$DetailWrapper === void 0 ? Detail : _ref$DetailWrapper,
    _ref$MasterWrapper = _ref.MasterWrapper,
    MasterWrapper = _ref$MasterWrapper === void 0 ? Master : _ref$MasterWrapper,
    _ref$ContainerWrapper = _ref.ContainerWrapper,
    ContainerWrapper = _ref$ContainerWrapper === void 0 ? Container : _ref$ContainerWrapper,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var targetProps = {
    selected: selected,
    onSelect: onSelect
  };
  var hasExpandedDetail = selected !== undefined;
  var className = (0, _classnames["default"])({
    hasExpandedDetail: hasExpandedDetail
  });
  var onClick = !hasExpandedDetail ? undefined : function () {
    return onSelect();
  };
  return /*#__PURE__*/_react["default"].createElement(ContainerWrapper, _extends({
    "data-testid": "MasterDetailView"
  }, extra), /*#__PURE__*/_react["default"].createElement(MasterWrapper, {
    onClickCapture: onClick,
    className: className
  }, renderMaster(targetProps)), hasExpandedDetail ? /*#__PURE__*/_react["default"].createElement(DetailWrapper, {
    className: className
  }, renderDetail(targetProps)) : null, children);
}